(function(){
  var S2S_SCRIPT_VERSION = "2026-10-20.02";
  if (window.__S2S_CART_INSTALLED__) return;
  window.__S2S_CART_INSTALLED__ = true;
  window.__S2S_CART_VERSION__ = S2S_SCRIPT_VERSION;
  // Self-configure from the <script> tag's own URL: /s2s-cart.js?store=...&ws=...&api=...
  var _self = (function(){
    try {
      if (document.currentScript && document.currentScript.src) return document.currentScript.src;
    } catch(e){}
    var tags = document.getElementsByTagName("script");
    for (var i = tags.length - 1; i >= 0; i--){
      var s = tags[i].getAttribute("src") || "";
      if (s.indexOf("/api/public/s2s-cart.js") !== -1) return s;
    }
    return "";
  })();
  var _u; try { _u = new URL(_self, window.location.origin); } catch(e){ _u = null; }
  var _q = _u ? _u.searchParams : { get: function(){ return null; } };
  var _apiFromScript = _u ? (_u.origin) : "";
  var cfg = Object.assign({
    workspace_id: _q.get("ws") || null,
    vitrine_store_id: _q.get("store") || null,
    api_base: _q.get("api") || _apiFromScript || ""
  }, window.S2SConfig || {});
  window.S2SConfig = cfg;
  var API = cfg.api_base || "";
  var STORAGE_KEY = "s2s_cart";
  var ATTR_KEY = "s2s_attr";
  var SETTINGS = {
    position: "bottom-right",
    primary_color: "#6366f1",
    button_text: "Finalizar compra",
    show_target_store: false,
    currency: "BRL",
    locale: "pt-BR",
    hide_native_cart: true,
    use_native_cart: false,
    hide_express_checkout: true,
    drawer_config: null
  };
  var checkoutInFlight = false;
  var checkoutLoadingButton = null;
  var checkoutLoadingState = null;
  var PREPARED_KEY = "s2s_prepared_checkout_v12:" + cfg.workspace_id + ":" + cfg.vitrine_store_id;
  var preparedCheckouts = {};
  var routePollingEnabled = false;
  var preparePromises = {};
  var prepareTimer = null;
  var prepareGeneration = 0;
  var warmedCheckoutOrigins = {};
  var lastNativeItems = [];
  var nativeCartSyncTimer = null;
  var activeCart = "pending";
  var nativeModeStarted = false;
  var syncNativeCartNow = null;
  var nativeCartDirty = true;
  var nativeCartPending = 0;
  var nativeCartRevision = 0;
  var nativeCartRead = null;
  var bindCheckoutRoot = null;
  var upcartSubscription = null;
  function cartUrl(path){ return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + path; }
  function detectExternalCart(){
    if (document.querySelector('script[src*="widget.razecart.com"], #hc-drawer #hc-checkout')) return "razecart";
    if (window.upcartDocumentOrShadowRoot || document.querySelector('#upCart, #upcart, upcart-cart, [class*="upcart-public-component-tag"], script[src*="upcart"]')) return "upcart";
    return null;
  }
  function reportCart(){
    var template = SETTINGS.drawer_config && SETTINGS.drawer_config.template || (activeCart === "shop2shops" ? "rocketz" : activeCart);
    window.__S2S_CART_INTEGRATION__ = { provider:activeCart, template:template, checkout_owner:"shop2shops", version:S2S_SCRIPT_VERSION, cart_ready:!nativeCartDirty && !nativeCartPending };
    document.documentElement.setAttribute("data-s2s-cart-provider", activeCart);
    document.documentElement.setAttribute("data-s2s-cart-template", template);
    document.documentElement.setAttribute("data-s2s-cart-version", S2S_SCRIPT_VERSION);
  }
  function updateRazeButton(){
    if (activeCart !== "razecart") return;
    var button = document.querySelector("#hc-drawer #hc-checkout");
    if (!button) return;
    // Only RazeCart's known session gate is replaced. Never unlock arbitrary
    // native/UpCart disabled buttons (terms, inventory or cart updates).
    var disabled = checkoutInFlight || nativeCartDirty || nativeCartPending > 0 || !lastNativeItems.length;
    if (button.disabled !== disabled) button.disabled = disabled;
    if (button.getAttribute("data-s2s-checkout-owner") !== "shop2shops") button.setAttribute("data-s2s-checkout-owner", "shop2shops");
  }
  function connectUpcart(){
    if (activeCart !== "upcart") return;
    var root = window.upcartDocumentOrShadowRoot;
    if (root && bindCheckoutRoot) bindCheckoutRoot(root);
    if (typeof window.upcartSubscribeCartLoaded === "function" && upcartSubscription !== window.upcartSubscribeCartLoaded) {
      upcartSubscription = window.upcartSubscribeCartLoaded;
      upcartSubscription(function(){
        var currentRoot = window.upcartDocumentOrShadowRoot;
        if (currentRoot && bindCheckoutRoot) bindCheckoutRoot(currentRoot);
        nativeCartDirty = true; nativeCartRevision++; invalidatePreparedCheckout();
        if (syncNativeCartNow) syncNativeCartNow().catch(function(){});
      });
    }
  }
  var SETTINGS_KEY = "s2s_settings_cache";
  var PIXELS_KEY = "s2s_tracking_pixels_cache";
  var browserMetaPixels = {};
  var pageViewTracked = false;
  // ===== i18n (auto: idioma da loja do usuário) =====
  var I18N = {
    pt: { processing:"Redirecionando…", giftFree:"Grátis", giftLabel:"Brinde", save:"Economize", loading:["Preparando seu checkout…","Conectando ao pagamento…","Quase pronto…"] },
    en: { processing:"Redirecting…", giftFree:"Free", giftLabel:"Gift", save:"Save", loading:["Preparing your checkout…","Connecting to payment…","Almost ready…"] },
    es: { processing:"Redirigiendo…", giftFree:"Gratis", giftLabel:"Regalo", save:"Ahorra", loading:["Preparando tu pago…","Conectando con el pago…","Casi listo…"] },
    fr: { processing:"Redirection…", giftFree:"Gratuit", giftLabel:"Cadeau", save:"Économisez", loading:["Préparation du paiement…","Connexion au paiement…","Presque prêt…"] },
    de: { processing:"Weiterleitung…", giftFree:"Kostenlos", giftLabel:"Geschenk", save:"Spare", loading:["Checkout wird vorbereitet…","Zahlung wird verbunden…","Fast geschafft…"] },
    it: { processing:"Reindirizzamento…", giftFree:"Gratis", giftLabel:"Omaggio", save:"Risparmia", loading:["Preparazione del checkout…","Connessione al pagamento…","Quasi pronto…"] },
    nl: { processing:"Doorsturen…", giftFree:"Gratis", giftLabel:"Cadeau", save:"Bespaar", loading:["Checkout voorbereiden…","Verbinden met betaling…","Bijna klaar…"] },
    pl: { processing:"Przekierowywanie…", giftFree:"Gratis", giftLabel:"Prezent", save:"Oszczędzasz", loading:["Przygotowujemy płatność…","Łączymy z płatnością…","Prawie gotowe…"] },
    ja: { processing:"移動中…", giftFree:"無料", giftLabel:"ギフト", save:"割引", loading:["チェックアウトを準備中…","決済に接続中…","まもなく完了します…"] },
    ar: { processing:"جارٍ التحويل…", giftFree:"مجاني", giftLabel:"هدية", save:"وفّر", loading:["جارٍ تجهيز الدفع…","جارٍ الاتصال بالدفع…","أوشكنا على الانتهاء…"] }
  };
  function detectLang(){
    var l = "";
    try { if (window.Shopify && window.Shopify.locale) l = window.Shopify.locale; } catch(e){}
    if (!l) { try { l = document.documentElement.getAttribute("lang") || ""; } catch(e){} }
    if (!l) { try { l = navigator.language || ""; } catch(e){} }
    if (!l) l = SETTINGS.locale || "pt";
    return String(l).toLowerCase().split("-")[0];
  }
  var shopCartCurrency = "";
  var shopCurrencyAtRead = "";
  function currencyCode(value){
    var code = String(value || "").trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : "";
  }
  function activeShopCurrency(){
    var shop = window.Shopify || {};
    return currencyCode(typeof shop.currency === "string" ? shop.currency : shop.currency && (shop.currency.active || shop.currency.current));
  }
  function applyShopCartContext(cart){
    var next = currencyCode(cart && cart.currency);
    if (!next) return;
    var previous = buyerContext().currency;
    shopCartCurrency = next;
    shopCurrencyAtRead = activeShopCurrency();
    if (previous !== next) {
      productPriceCache = {};
      invalidatePreparedCheckout();
    }
  }
  function buyerContext(){
    var locale = "", country = "", currency = "";
    var liquid = window.__S2S_SHOP_CONTEXT__ || {};
    try { locale = (window.Shopify && window.Shopify.locale) || ""; } catch(e){}
    if (!locale) { try { locale = document.documentElement.getAttribute("lang") || ""; } catch(e){} }
    if (!locale) { try { locale = navigator.language || ""; } catch(e){} }
    if (!locale) locale = liquid.locale || SETTINGS.locale || "";
    try {
      country = (window.Shopify && (window.Shopify.country || (window.Shopify.localization && window.Shopify.localization.country && window.Shopify.localization.country.iso_code))) || "";
    } catch(e){}
    var active = activeShopCurrency();
    // Ajax cart.currency describes the currency of the actual returned prices.
    // A changed Shopify selector invalidates that snapshot without waiting for
    // a checkout click. The editor currency is only a last-resort fallback.
    currency = shopCartCurrency && active === shopCurrencyAtRead ? shopCartCurrency : active;
    if (!currency) currency = currencyCode(liquid.currency) || currencyCode(SETTINGS.currency);
    if (!country) country = liquid.country || "";
    if (!locale) locale = liquid.locale || "";
    locale = String(locale).trim().replace(/_/g,"-").toLowerCase();
    country = String(country).trim().toUpperCase();
    currency = String(currency).trim().toUpperCase();
    return {
      locale: /^[a-z]{2}(-[a-z]{2})?$/.test(locale) ? locale : "",
      country: /^[A-Z]{2}$/.test(country) ? country : "",
      currency: /^[A-Z]{3}$/.test(currency) ? currency : ""
    };
  }
  function checkoutBuyerContext(){
    var context = buyerContext();
    var selected = "";
    try {
      if (window.bucksCC && document.querySelector) {
        var label = document.querySelector(".bucks-selected");
        selected = currencyCode(label && label.textContent);
        if (!selected) {
          var price = document.querySelector("[bucks-currency]");
          selected = currencyCode(price && price.getAttribute("bucks-currency"));
        }
      }
    } catch(e){}
    return { locale:context.locale, country:context.country, currency:selected || context.currency, currency_selected:!!selected };
  }
  function t(key){
    var d = I18N[detectLang()] || I18N.en;
    return d[key] || I18N.en[key] || "";
  }
  function loadingTexts(){
    var d = I18N[detectLang()] || I18N.en;
    return d.loading || I18N.en.loading;
  }

  // ===== Loading discreto no próprio botão de checkout =====
  function showCheckoutLoader(triggerEl){
    var button = triggerEl || checkoutLoadingButton || document.getElementById("s2s-go");
    if (!button || checkoutLoadingButton === button) return;
    hideCheckoutLoader();
    if (!document.getElementById("s2s-inline-loading-style")) {
      var st = document.createElement("style");
      st.id = "s2s-inline-loading-style";
      st.textContent = "@keyframes s2s-button-spin{to{transform:rotate(360deg)}}"+
        ".s2s-checkout-loading{cursor:wait!important}"+
        ".s2s-checkout-loading .s2s-button-content{display:inline-flex;align-items:center;justify-content:center;gap:9px}"+
        ".s2s-checkout-loading .s2s-button-spinner{display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-right-color:transparent;border-radius:9999px;animation:s2s-button-spin .65s linear infinite;flex:0 0 auto}"+
        "@media(prefers-reduced-motion:reduce){.s2s-checkout-loading .s2s-button-spinner{animation-duration:1.4s}}";
      document.documentElement.appendChild(st);
    }
    var isInput = button.tagName === "INPUT";
    checkoutLoadingButton = button;
    checkoutLoadingState = {
      html: isInput ? null : button.innerHTML,
      value: isInput ? button.value : null,
      minWidth: button.style.minWidth || "",
      disabled: !!button.disabled
    };
    try { button.style.minWidth = Math.ceil(button.getBoundingClientRect().width) + "px"; } catch(e){}
    button.setAttribute("aria-busy", "true");
    button.setAttribute("aria-disabled", "true");
    button.classList.add("s2s-checkout-loading");
    if (isInput) button.value = t("processing");
    else button.innerHTML = '<span class="s2s-button-content"><span class="s2s-button-spinner" aria-hidden="true"></span><span>'+escapeHtml(t("processing"))+'</span></span>';
  }
  function hideCheckoutLoader(){
    var button = checkoutLoadingButton;
    var state = checkoutLoadingState;
    if (button && state) {
      try {
        if (state.html !== null) button.innerHTML = state.html;
        if (state.value !== null) button.value = state.value;
        button.style.minWidth = state.minWidth;
        button.removeAttribute("aria-busy");
        button.removeAttribute("aria-disabled");
        button.classList.remove("s2s-checkout-loading");
      } catch(err){}
    }
    checkoutLoadingButton = null;
    checkoutLoadingState = null;
  }
  function acquireCheckoutLock(){ if (checkoutInFlight) return false; checkoutInFlight = true; return true; }
  function releaseCheckoutLock(){ checkoutInFlight = false; hideCheckoutLoader(); updateRazeButton(); }




  function giftConfig(){ return SETTINGS.drawer_config && SETTINGS.drawer_config.gift || {}; }
  function isGiftItem(item){ return !!(item && item.is_gift === true); }
  function withConfiguredGift(items){
    var gift = giftConfig();
    var regular = (items || []).filter(function(item){ return !isGiftItem(item); });
    var preparedVariantId = String(gift.preparedSourceVariantId || "").trim();
    if (gift.enabled !== true || !preparedVariantId || !regular.length) return regular;
    regular.push({
      variant_id:preparedVariantId,
      product_id:"rocketz-gift",
      title:gift.productTitle || t("giftLabel"),
      variant_title:gift.variantTitle && gift.variantTitle !== "Default Title" ? gift.variantTitle : null,
      price:0,
      compare_at_price:0,
      image:gift.imageUrl || "",
      quantity:1,
      is_gift:true
    });
    return regular;
  }
  function load(){
    try { return withConfiguredGift(JSON.parse(localStorage.getItem(STORAGE_KEY)||"[]")); }
    catch(e){ return []; }
  }
  function save(items){
    items = withConfiguredGift(items);
    var previousItems = load();
    var nextKey = cartFingerprint(items);
    var changed = cartFingerprint(previousItems) !== nextKey;
    var ready = readPreparedCheckout(items);
    var preparing = !!preparePromises[nextKey];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    if (changed && !ready && !preparing) invalidatePreparedCheckout();
    if (typeof window.__s2s_render === "function") window.__s2s_render();
    if (!ready && !preparing) schedulePrepareChoices(items, 0);
  }
  function fmt(c){
    var context = buyerContext();
    try { return new Intl.NumberFormat(context.locale || SETTINGS.locale, { style:"currency", currency: context.currency || SETTINGS.currency }).format(Number(c)||0); }
    catch(e){ return (context.currency || SETTINGS.currency || "") + " " + (Number(c)||0).toFixed(2); }
  }

  // Use the storefront converter itself, including its rates, rounding and
  // selected currency. Keep numeric Shopify prices in their real source
  // currency for checkout/pixels; this is the presentation layer only.
  function moneyHtml(value){
    return '<span class="money s2s-money">' + escapeHtml(fmt(value)) + '</span>';
  }
  function syncStorefrontMoney(){
    try {
      var converter = window.bucksCC;
      if (converter && typeof converter.reConvert === "function") converter.reConvert();
    } catch(error){ console.error("[s2s] storefront currency conversion failed",error); }
  }

  // ===== Attribution capture =====
  function getCookie(name){
    var m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\/\+^])/g,'\\$1') + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : undefined;
  }
  function captureAttribution(){
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem(ATTR_KEY)||"{}"); } catch(e){}
    var qs = new URLSearchParams(window.location.search);
    var fbclid = qs.get("fbclid"); if (fbclid) stored.fbclid = fbclid;
    var gclid  = qs.get("gclid");  if (gclid)  stored.gclid  = gclid;
    var ttclid = qs.get("ttclid"); if (ttclid) stored.ttclid = ttclid;
    var fbp = getCookie("_fbp"); if (fbp) stored.fbp = fbp;
    var fbc = getCookie("_fbc"); if (fbc) stored.fbc = fbc;
    var ttp = getCookie("_ttp"); if (ttp) stored.ttp = ttp;
    var ga = getCookie("_ga");
    if (ga) {
      var gaParts = ga.split(".");
      if (gaParts.length >= 4) stored.ga_client_id = gaParts.slice(-2).join(".");
    }
    if (!stored.fbc && stored.fbclid) stored.fbc = "fb.1." + Date.now() + "." + stored.fbclid;
    localStorage.setItem(ATTR_KEY, JSON.stringify(stored));
    return stored;
  }
  function getAttribution(){ try { return JSON.parse(localStorage.getItem(ATTR_KEY)||"{}"); } catch(e){ return {}; } }
  function uuid(){ return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,function(c){ return (c^crypto.getRandomValues(new Uint8Array(1))[0]&15>>c/4).toString(16); }); }

  function initMetaPixel(pixelId){
    pixelId = String(pixelId || "").trim();
    if (!pixelId || browserMetaPixels[pixelId]) return;
    browserMetaPixels[pixelId] = true;
    try {
      if (!window.fbq) {
        var n = window.fbq = function(){ n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!window._fbq) window._fbq = n;
        n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
        var script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        var firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
        else (document.head || document.documentElement).appendChild(script);
      }
      window.fbq("init", pixelId);
    } catch(e){}
  }

  function configureBrowserPixels(pixels){
    if (!Array.isArray(pixels)) return;
    pixels.forEach(function(pixel){
      if (pixel && pixel.enabled !== false && pixel.platform === "meta") initMetaPixel(pixel.pixel_id);
    });
  }

  function browserTrack(eventName, custom, eventId){
    if (!Object.keys(browserMetaPixels).length || typeof window.fbq !== "function") return;
    try { window.fbq("track", eventName, custom || {}, { eventID: eventId }); } catch(e){}
  }

  function track(eventName, custom, suppliedEventId){
    if (!cfg.workspace_id || !cfg.vitrine_store_id) return;
    var eventId = suppliedEventId || uuid();
    browserTrack(eventName, custom, eventId);
    var payload = JSON.stringify({
      workspace_id: cfg.workspace_id, vitrine_store_id: cfg.vitrine_store_id,
      event_name: eventName, event_id: eventId,
      event_source_url: window.location.href, attribution: getAttribution(), custom: custom||{}
    });
    function send(attempt){
    fetch(API + "/api/public/s2s-track", {
      method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
      body: payload
    }).then(function(response){ if (response.status >= 500) throw new Error("Tracking unavailable"); })
      .catch(function(){ if (!attempt) setTimeout(function(){ send(1); }, 1000); });
    }
    send(0);
  }

  function trackPageViewOnce(){
    if (pageViewTracked) return;
    pageViewTracked = true;
    track("PageView", {});
    // A product view is not a generic page view. Resolve the actual vitrine product.
    var match = window.location.pathname.match(/\/products\/([^/]+)/);
    if (match) {
      fetch(cartUrl("products/" + match[1] + ".js"), { headers: { "Accept":"application/json" } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(product){
          if (!product || !product.id) return;
          track("ViewContent", { content_ids:[String(product.id)], product_items:[{ product_id:String(product.id), quantity:1 }], currency:buyerContext().currency, value:Number(product.price || 0) / 100 });
        }).catch(function(){});
    }
  }

  captureAttribution();

  // ===== Checkout preparado antes do clique =====
  function shippingProtectionSelected(){
    var protection = document.getElementById(activeCart === "shop2shops" ? "s2s-shipping-protection-toggle" : "hc-shipping-protection-toggle");
    return !!(protection && protection.checked);
  }
  function cartFingerprint(items, protectionOverride){
    var protectionEnabled = typeof protectionOverride === "boolean" ? protectionOverride : shippingProtectionSelected();
    var protectionKey = protectionEnabled ? "|insurance:1" : "|insurance:0";
    var context = checkoutBuyerContext();
    var contextKey = "|ctx:" + context.locale + ":" + context.country + ":" + context.currency + ":" + context.currency_selected;
    return (items || []).map(function(item){
      return String(item.variant_id) + ":" + Math.max(1, Number(item.quantity) || 1);
    }).sort().join("|") + protectionKey + contextKey;
  }

  function readPreparedCheckout(items, protectionOverride){
    var key = cartFingerprint(items, protectionOverride);
    if (!key) return null;
    var memoryPlan = preparedCheckouts[key];
    if (memoryPlan && memoryPlan.expires_at > Date.now() && (!memoryPlan.route_revision || Date.now() - memoryPlan.revision_verified_at < 20000)) {
      warmCheckoutDestination(memoryPlan.checkout_url);
      return memoryPlan;
    }
    try {
      var cached = JSON.parse(sessionStorage.getItem(PREPARED_KEY) || "null");
      var cachedPlans = cached && cached.plans ? cached.plans : {};
      var cachedPlan = cachedPlans[key];
      if (cachedPlan && cachedPlan.checkout_url && cachedPlan.expires_at > Date.now() && (!cachedPlan.route_revision || Date.now() - cachedPlan.revision_verified_at < 20000)) {
        preparedCheckouts[key] = cachedPlan;
        warmCheckoutDestination(cachedPlan.checkout_url);
        return cachedPlan;
      }
    } catch(e){}
    return null;
  }

  function persistPreparedCheckouts(){
    var now = Date.now();
    Object.keys(preparedCheckouts).forEach(function(key){
      if (!preparedCheckouts[key] || preparedCheckouts[key].expires_at <= now) delete preparedCheckouts[key];
    });
    try { sessionStorage.setItem(PREPARED_KEY, JSON.stringify({ plans:preparedCheckouts })); } catch(e){}
  }

  function invalidatePreparedCheckout(){
    prepareGeneration++;
    preparedCheckouts = {};
    preparePromises = {};
    try { sessionStorage.removeItem(PREPARED_KEY); } catch(e){}
  }

  // Resolve DNS/TLS da loja de destino antes do clique. Não acessa o checkout
  // antecipadamente e não altera o carrinho; apenas reduz o custo da navegação.
  function warmCheckoutDestination(checkoutUrl){
    try {
      var origin = new URL(checkoutUrl, window.location.href).origin;
      if (!origin || warmedCheckoutOrigins[origin]) return;
      warmedCheckoutOrigins[origin] = true;
      ["dns-prefetch", "preconnect"].forEach(function(rel){
        var link = document.createElement("link");
        link.rel = rel;
        link.href = origin;
        if (rel === "preconnect") link.crossOrigin = "anonymous";
        (document.head || document.documentElement).appendChild(link);
      });
    } catch(e){}
  }

  function prepareCheckout(items, force, protectionOverride, preferredStoreId){
    var protectionEnabled = typeof protectionOverride === "boolean" ? protectionOverride : shippingProtectionSelected();
    var key = cartFingerprint(items, protectionEnabled);
    var context = checkoutBuyerContext();
    var generation = prepareGeneration;
    if (!key || !cfg.workspace_id || !cfg.vitrine_store_id || !API) return Promise.resolve(null);
    var ready = !force && readPreparedCheckout(items, protectionEnabled);
    if (ready) return Promise.resolve(ready);
    if (preparePromises[key]) return preparePromises[key];

    var requestPromise = fetch(API + "/api/public/s2s-checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal: AbortSignal.timeout(12000),
      body: JSON.stringify({
        mode: "prepare",
        workspace_id: cfg.workspace_id,
        vitrine_store_id: cfg.vitrine_store_id,
        items: items,
        shipping_protection: protectionEnabled,
        preferred_store_id: preferredStoreId || undefined,
        buyer_locale: context.locale,
        buyer_country: context.country,
        buyer_currency: context.currency,
        buyer_currency_selected: context.currency_selected,
        attribution: getAttribution(),
        event_source_url: window.location.href
      })
    }).then(function(r){
      return r.json().then(function(d){ return { ok:r.ok, status:r.status, data:d }; })
        .catch(function(){ return { ok:r.ok, status:r.status, data:null }; });
    }).then(function(res){
      var d = res.data;
      if (!res.ok || !d || !d.checkout_url) {
        throw new Error((d && d.error) || ("Não foi possível preparar o checkout (HTTP " + res.status + ")"));
      }
      var plan = {
        cart_key: key,
        checkout_url: d.checkout_url,
        session_token: d.session_token,
        tracking_event_id: d.tracking_event_id,
        target_store_id: d.target_store_id || preferredStoreId || null,
        checkout_method: d.checkout_method || "direct",
        distribution_rule: d.distribution_rule || "round_robin:direct",
        shopify_draft_order_id: d.shopify_draft_order_id || null,
        route_revision: d.route_revision || null,
        revision_verified_at: Date.now(),
        expires_at: Date.now() + Math.max(5000, Number(d.expires_in_ms) || 300000)
      };
      if (plan.route_revision) routePollingEnabled = true;
      if (generation === prepareGeneration) {
        preparedCheckouts[key] = plan;
        persistPreparedCheckouts();
        warmCheckoutDestination(plan.checkout_url);
        window.__S2S_PREPARED_CHECKOUT__ = { ready:true, cart_key:key };
      }
      if (generation !== prepareGeneration) throw new Error("A rota mudou. Tente novamente.");
      return plan;
    });
    preparePromises[key] = requestPromise;

    requestPromise.then(function(){
      if (preparePromises[key] === requestPromise) delete preparePromises[key];
    }, function(){
      if (preparePromises[key] === requestPromise) delete preparePromises[key];
    });
    return requestPromise;
  }

  function schedulePrepare(items, delay){
    if (!items || !items.length) { invalidatePreparedCheckout(); return; }
    if (readPreparedCheckout(items)) return;
    var key = cartFingerprint(items);
    if (preparePromises[key]) return;
    if (prepareTimer) clearTimeout(prepareTimer);
    prepareTimer = setTimeout(function(){
      prepareTimer = null;
      prepareCheckout(items, false).catch(function(err){
        window.__S2S_PREPARED_CHECKOUT__ = { ready:false, error:String(err && err.message || err) };
      });
    }, typeof delay === "number" ? delay : 80);
  }

  function prepareCheckoutChoices(items){
    if (!items || !items.length) return Promise.resolve([]);
    var protectionToggle = document.getElementById(activeCart === "shop2shops" ? "s2s-shipping-protection-toggle" : "hc-shipping-protection-toggle");
    if (!protectionToggle) {
      return prepareCheckout(items, false, false).then(function(plan){ return [plan]; });
    }
    var selected = shippingProtectionSelected();
    return prepareCheckout(items, false, selected).then(function(primary){
      return prepareCheckout(items, false, !selected, primary && primary.target_store_id).then(function(alternate){
        return [primary, alternate];
      });
    });
  }

  function schedulePrepareChoices(items, delay){
    if (!items || !items.length) { invalidatePreparedCheckout(); return; }
    var protectionToggle = document.getElementById(activeCart === "shop2shops" ? "s2s-shipping-protection-toggle" : "hc-shipping-protection-toggle");
    if (protectionToggle && readPreparedCheckout(items, true) && readPreparedCheckout(items, false)) return;
    if (!protectionToggle && readPreparedCheckout(items, false)) return;
    if (prepareTimer) clearTimeout(prepareTimer);
    prepareTimer = setTimeout(function(){
      prepareTimer = null;
      prepareCheckoutChoices(items).catch(function(err){
        window.__S2S_PREPARED_CHECKOUT__ = { ready:false, error:String(err && err.message || err) };
      });
    }, typeof delay === "number" ? delay : 80);
  }

  function commitPreparedCheckout(plan){
    if (!plan || !plan.session_token) return Promise.reject(new Error("Sessão de checkout inválida. Tente novamente."));
    return fetch(API + "/api/public/s2s-checkout", {
      method:"POST",headers:{"Content-Type":"application/json"},signal:AbortSignal.timeout(10000),
      body:JSON.stringify({mode:"commit",session_token:plan.session_token,checkout_url:plan.checkout_url,
        checkout_method:plan.checkout_method,distribution_rule:plan.distribution_rule,shopify_draft_order_id:plan.shopify_draft_order_id})
    }).then(function(r){return r.json().then(function(d){if(!r.ok)throw new Error(d.error || "Checkout indisponível");return d;});});
  }

  function redirectToPreparedCheckout(plan, items){
    return commitPreparedCheckout(plan).then(function(){
    var context = buyerContext();
    var custom = {
      content_ids: items.map(function(item){ return String(item.variant_id); }),
      contents: items.map(function(item){ return { id:String(item.variant_id), quantity:item.quantity || 1, item_price:item.price || 0 }; }),
      num_items: items.reduce(function(total,item){ return total + (item.quantity || 1); }, 0),
      value: items.reduce(function(total,item){ return total + ((Number(item.price) || 0) * (item.quantity || 1)); }, 0),
      currency: context.currency || SETTINGS.currency
    };
    track("InitiateCheckout", custom, plan.tracking_event_id);
    localStorage.removeItem(STORAGE_KEY);
    try { sessionStorage.removeItem(PREPARED_KEY); } catch(e){}
    // Keep the storefront cart if navigation fails or the shopper goes back.
    navigatePreparedCheckout(plan);
    }).catch(function(err){
      invalidatePreparedCheckout();releaseCheckoutLock();hideCheckoutLoader();
      alert(err && err.message || "Não foi possível confirmar o checkout. Tente novamente.");
    });
  }

  function navigatePreparedCheckout(plan){
    var checkoutUrl = new URL(plan.checkout_url);
    var country = checkoutUrl.searchParams.get("country");
    if (checkoutUrl.protocol === "https:" && /^[A-Z]{2}$/.test(country || "")) {
      // Shopify's supported localization form selects the browsing Market in
      // the destination cookie session. URL currency alone can be ignored.
      // This is not a shipping address: Shopify may reprice after address entry.
      var marketForm = document.createElement("form");
      marketForm.method = "POST";
      marketForm.action = checkoutUrl.origin + "/localization";
      marketForm.style.display = "none";
      var fields = { form_type:"localization", _method:"put", country_code:country, return_to:checkoutUrl.pathname + checkoutUrl.search };
      Object.keys(fields).forEach(function(name){
        var input = document.createElement("input"); input.type = "hidden"; input.name = name; input.value = fields[name]; marketForm.appendChild(input);
      });
      document.body.appendChild(marketForm);
      marketForm.submit();
    } else window.location.assign(plan.checkout_url);
  }

  function absolutize(u){
    if (!u) return "";
    if (u.indexOf("//") === 0) return "https:" + u;
    return u;
  }

  var productPriceCache = {};
  var protectionMarketPrice = null;
  function protectionPriceValue(){
    var config = SETTINGS.drawer_config && SETTINGS.drawer_config.shippingProtection || {};
    return protectionMarketPrice && protectionMarketPrice.currency === buyerContext().currency
      ? protectionMarketPrice.price : Number(config.price)||0;
  }
  function refreshProtectionPrice(){
    var config = SETTINGS.drawer_config && SETTINGS.drawer_config.shippingProtection || {};
    if (!config.enabled || !config.sourceHandle || !config.preparedSourceVariantId) return Promise.resolve();
    var currency = buyerContext().currency;
    return localizedProduct(config.sourceHandle).then(function(product){
      if (buyerContext().currency !== currency) return;
      var variant = product && (product.variants || []).find(function(v){ return String(v.id) === String(config.preparedSourceVariantId); });
      if (variant && typeof variant.price === "number") protectionMarketPrice = { currency:currency, price:variant.price / 100 };
    });
  }
  function localizedProduct(handle){
    var key = buyerContext().currency + ":" + handle;
    if (!productPriceCache[key]) {
      productPriceCache[key] = fetch(cartUrl("products/" + encodeURIComponent(handle) + ".js"), {
        headers:{ "Accept":"application/json" }, signal:AbortSignal.timeout(5000)
      }).then(function(response){ return response.ok ? response.json() : null; }).catch(function(){ return null; });
    }
    return productPriceCache[key];
  }
  function refreshStoredPrices(){
    var currency = buyerContext().currency;
    var items = load();
    return Promise.all(items.filter(function(item){ return !isGiftItem(item) && item.handle && item.price_currency !== currency; }).map(function(item){
      return localizedProduct(item.handle).then(function(product){
        if (buyerContext().currency !== currency) return;
        var variant = product && (product.variants || []).find(function(v){ return String(v.id) === String(item.variant_id); });
        if (!variant || typeof variant.price !== "number") return;
        var current = load();
        var stored = current.find(function(v){ return String(v.variant_id) === String(item.variant_id); });
        if (!stored) return;
        stored.price = variant.price / 100;
        stored.compare_at_price = Number(variant.compare_at_price || 0) / 100;
        stored.price_currency = currency;
        save(current);
      });
    }));
  }
  function warmShopCurrency(){
    // Resolve on page load/open, not in the redirect's critical path.
    return fetch(cartUrl("cart.js"), { headers:{ "Accept":"application/json" }, signal:AbortSignal.timeout(5000) })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ applyShopCartContext(cart); return Promise.all([refreshStoredPrices(), refreshProtectionPrice()]); })
      .then(function(){ if (window.__s2s_render) window.__s2s_render(); schedulePrepareChoices(load(), 0); })
      .catch(function(){});
  }
  function compareAtPriceFromProduct(product, variantId){
    var variants = product && product.variants || [];
    var variant = variants.find(function(candidate){ return String(candidate.id) === String(variantId); });
    var value = variant && Number(variant.compare_at_price);
    return value > 0 ? value / 100 : 0;
  }
  function productHandleFromLine(line){
    var handle = line && (line.handle || line.product_handle) || "";
    if (handle) return String(handle);
    var url = line && (line.url || line.product_url) || "";
    var match = String(url).match(/\/products\/([^?#/]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }
  function loadCompareAtPrice(variantId, line){
    var directValue = line && Number(line.compare_at_price);
    if (directValue > 0) return Promise.resolve(directValue / 100);
    var handle = productHandleFromLine(line);
    if (!handle) return Promise.resolve(0);
    return localizedProduct(handle).then(function(product){ return compareAtPriceFromProduct(product, variantId); });
  }
  function hydrateCompareAtPrice(variantId, line){
    var currency = buyerContext().currency;
    loadCompareAtPrice(variantId, line).then(function(compareAtPrice){
      if (buyerContext().currency !== currency) return;
      if (!(compareAtPrice > 0)) return;
      var items = load();
      var item = items.find(function(candidate){ return String(candidate.variant_id) === String(variantId); });
      if (!item || Number(item.compare_at_price) === compareAtPrice) return;
      item.compare_at_price = compareAtPrice;
      save(items);
    }).catch(function(){});
  }

  function anticipatedItemsFromForm(form){
    try {
      var fd = new FormData(form);
      var variantId = String(fd.get("id") || "").trim();
      if (!/^\d+$/.test(variantId)) return null;
      var quantity = Math.max(1, Number(fd.get("quantity")) || 1);
      var items = load().map(function(item){ return Object.assign({}, item); });
      var existing = items.find(function(item){ return String(item.variant_id) === variantId; });
      if (existing) existing.quantity += quantity;
      else items.push({ variant_id:variantId, quantity:quantity });
      return withConfiguredGift(items);
    } catch(e){ return null; }
  }

  // Add via Shopify AJAX cart to get title/price/image/variant_title reliably, then clear native cart.
  function addFromForm(form){
    var fd = new FormData(form);
    // Começa a resolver loja e variantes no primeiro instante do clique,
    // em paralelo com /cart/add.js. A resposta da Shopify apenas completa
    // título, preço e imagem; não precisa bloquear o pré-checkout.
    var anticipatedItems = anticipatedItemsFromForm(form);
    if (anticipatedItems && anticipatedItems.length) {
      var anticipatedKey = cartFingerprint(anticipatedItems);
      var anticipatedReady = readPreparedCheckout(anticipatedItems);
      var anticipatedPreparing = !!preparePromises[anticipatedKey];
      if (!anticipatedReady && !anticipatedPreparing) {
        invalidatePreparedCheckout();
        schedulePrepareChoices(anticipatedItems, 0);
      }
    }
    fetch(cartUrl("cart/add.js"), { method: "POST", body: fd, headers: { "Accept": "application/json" } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(line){
        if (!line || !line.id) return;
        var items = load();
        var vid = String(line.variant_id || line.id);
        var existing = items.find(function(i){ return String(i.variant_id) === vid; });
        var qty = line.quantity || 1;
        if (existing) {
          existing.quantity += qty;
          existing.price = Number(line.price || 0) / 100;
          existing.price_currency = buyerContext().currency;
          existing.handle = productHandleFromLine(line) || existing.handle;
        }
        else {
          items.push({
            variant_id: vid,
            product_id: line.product_id,
            title: line.product_title || line.title || ("Variante " + vid),
            variant_title: line.variant_title || null,
            price: (typeof line.price === "number" ? line.price : 0) / 100,
            price_currency: buyerContext().currency,
            compare_at_price: (typeof line.compare_at_price === "number" ? line.compare_at_price : 0) / 100,
            handle: productHandleFromLine(line),
            image: absolutize(line.image || line.featured_image && line.featured_image.url || ""),
            quantity: qty
          });
        }
        save(items);
        hydrateCompareAtPrice(vid, line);
        track("AddToCart", {
          product_items: line.product_id ? [{ product_id:String(line.product_id), quantity:qty }] : [],
          currency: buyerContext().currency,
          value: ((line.price || 0) / 100) * qty,
          content_ids: [vid],
          contents: [{ id: vid, quantity: qty, item_price: (line.price || 0) / 100 }],
          num_items: qty
        });
        // Clear Shopify's native cart so only our drawer holds items.
        fetch(cartUrl("cart/clear.js"), { method: "POST", headers: { "Accept": "application/json" } }).catch(function(){});
        if (window.__s2s_openPanel) window.__s2s_openPanel();
      })
      .catch(function(){});
  }

  function removeItem(vid){ save(load().filter(function(i){ return String(i.variant_id) !== String(vid); })); }
  function setQty(vid, q){
    var items = load();
    items.forEach(function(i){ if (String(i.variant_id)===String(vid)) i.quantity = Math.max(1, q); });
    save(items);
  }

  function escapeHtml(s){ return String(s).replace(/[&<>"]/g,function(c){return ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"})[c];}); }

  function cartImageUrl(source, width){
    var raw = String(source || "").trim();
    if (!raw) return "";
    try {
      var url = new URL(raw, window.location.origin);
      var isShopifyImage = url.hostname === "cdn.shopify.com" || url.pathname.indexOf("/cdn/shop/") !== -1;
      if (!isShopifyImage) return url.href;
      url.pathname = url.pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)(?:_crop_[^./?]+)?(?=\.[a-z0-9]+$)/i, "");
      url.searchParams.delete("height");
      url.searchParams.delete("crop");
      url.searchParams.set("width", String(width));
      return url.href;
    } catch(e){ return raw; }
  }

  function cartImageMarkup(item, minimal){
    var displayWidth = minimal ? 92 : 56;
    var displayHeight = minimal ? 72 : 56;
    var image = item && item.image || "";
    var oneX = cartImageUrl(image, displayWidth);
    var twoX = cartImageUrl(image, displayWidth * 2);
    var threeX = cartImageUrl(image, displayWidth * 3);
    return '<img src="'+escapeHtml(twoX)+'" srcset="'+escapeHtml(oneX)+' '+displayWidth+'w, '+escapeHtml(twoX)+' '+(displayWidth * 2)+'w, '+escapeHtml(threeX)+' '+(displayWidth * 3)+'w" sizes="'+displayWidth+'px" width="'+displayWidth+'" height="'+displayHeight+'" alt="'+escapeHtml(item && item.title || "")+'">';
  }

  // ============================================================
  // MODE A: Nosso drawer (default)
  // ============================================================
  function initDrawerMode(){
    var dc = SETTINGS.drawer_config || {};
    var isMinimalShopCart = dc.template === "minimal-shop-cart";
    var ds = dc.style || {};
    var dh = dc.header || {};
    var dcheckout = dc.checkoutButton || {};
    var dprotection = dc.shippingProtection || {};
    var protectionEnabled = dprotection.enabled === true;
    function stopNativeCartEvent(e){
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    function isAddForm(form){
      return form instanceof HTMLFormElement &&
        (form.getAttribute("action")||"").toLowerCase().indexOf("/cart/add") !== -1;
    }
    // Interceptar no window/capture garante precedência sobre o tema e apps.
    // Cobre submit por teclado e scripts que chamam requestSubmit().
    window.addEventListener("submit", function(e){
      if (activeCart !== "shop2shops") return;
      var form = e.target;
      if (!isAddForm(form)) return;
      stopNativeCartEvent(e);
      addFromForm(form);
    }, true);

    function isNativeCartTrigger(el){
      if (!el || !el.matches || el.closest(".s2s-panel, .s2s-btn")) return false;
      var matchesCartSelector = el.matches([
        "#cart-icon-bubble",
        "a[href='/cart']",
        "a[href^='/cart?']",
        "a[href^='/cart#']",
        "[aria-controls='CartDrawer']",
        "[aria-controls='cart-drawer']",
        "[data-cart-drawer-trigger]",
        "[data-cart-toggle]"
      ].join(","));
      if (!matchesCartSelector) return false;
      // Alguns temas usam os atributos acima em containers inteiros. Só um
      // controle realmente interativo pode abrir o drawer; assim cliques em
      // seletores de variante dentro desses containers continuam com o tema.
      return el.id === "cart-icon-bubble" || el.tagName === "A" || el.tagName === "BUTTON" || el.getAttribute("role") === "button";
    }

    // Um clique em adicionar não pode chegar ao drawer do tema/HeroCart.
    window.addEventListener("click", function(e){
      if (activeCart !== "shop2shops") return;
      var path = e.composedPath ? e.composedPath() : [];
      var t = path[0] || e.target;
      while (t && t !== document.body) {
        if (t.nodeType === 1 && isNativeCartTrigger(t)) {
          stopNativeCartEvent(e);
          openPanel();
          return;
        }
        t = t.parentNode || t.host;
      }
    }, true);

    // Hide native Shopify cart UI (drawer, sidebar, mini-cart, cart bubble)
    if (SETTINGS.hide_native_cart) {
      var s = document.createElement("style");
      s.id = "s2s-hide-native";
      s.textContent = [
        "#CartDrawer, #cart-drawer, cart-drawer, .cart-drawer, .cart__drawer,",
        "#sidebar-cart, #mini-cart, .mini-cart, .drawer--cart, .cart-popup,",
        "[data-cart-drawer], [data-cart-popup], .js-drawer-open-cart,",
        "#herocart-root, #hc-overlay, #hc-drawer,",
        ".cart-count-bubble, .cart-link__bubble, .header__cart-count,",
        ".site-header__cart-count, .cart-item-count, .cart-notification,",
        "#cart-notification, cart-notification {",
        "  display: none !important; visibility: hidden !important; pointer-events: none !important;",
        "}"
      ].join("");
      document.head.appendChild(s);
    }

    // Drawer styles
    var styleEl = document.createElement("style");
    styleEl.textContent = ".s2s-btn{display:none!important}"+
      ".s2s-btn svg{width:26px;height:26px}"+
      ".s2s-badge{position:absolute;top:-4px;right:-4px;background:#ef4444;color:#fff;border-radius:9999px;min-width:20px;height:20px;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 6px}"+
      ".s2s-overlay{position:fixed;inset:0;background:"+(ds.overlayColor||"rgba(0,0,0,.4)")+";z-index:2147483000;display:none}"+
      ".s2s-panel{position:fixed;top:0;right:0;height:100%;width:420px;max-width:100vw;background:"+(ds.drawerBgColor||"#fff")+";z-index:2147483001;display:flex;flex-direction:column;transform:translateX(100%);transition:transform "+((dc.animation&&dc.animation.duration)||"250ms")+" ease;box-shadow:-10px 0 30px rgba(0,0,0,.2);font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:"+(ds.itemTextColor||"#111")+"}"+
      ".s2s-panel.open{transform:translateX(0)}"+
      ".s2s-head{display:flex;align-items:center;justify-content:space-between;padding:18px;border-bottom:1px solid "+(ds.dividerColor||"#eee")+";font-size:"+(dh.fontSize||"18px")+";font-weight:"+(dh.fontWeight||"600")+";color:"+(ds.headerTextColor||"#111")+";background:"+(ds.headerBgColor||"#fff")+"}"+
      ".s2s-x{background:none;border:none;font-size:22px;cursor:pointer}"+
      ".s2s-items{flex:1;overflow:auto;padding:8px 16px}"+
      ".s2s-item{display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f1f1f1}"+
      ".s2s-item img{width:56px;height:56px;object-fit:contain;border-radius:6px;background:#ffffff}"+
      ".s2s-item-copy{flex:1;min-width:0}.s2s-item-side{display:flex;flex-direction:column;align-items:flex-end;min-width:0;text-align:right}.s2s-remove{background:none;border:none;color:#999;cursor:pointer;padding:0}.s2s-item-prices{display:flex;align-items:baseline;gap:7px;margin-top:4px}.s2s-compare-price{font-size:12px;color:#999;text-decoration:line-through}.s2s-current-price{font-size:13px;font-weight:650}.s2s-saving{font-size:11px;line-height:1.15;font-weight:700;color:#16a34a;white-space:nowrap}.s2s-gift-price{color:#16a34a}.s2s-gift-qty{display:inline-flex;margin-top:7px;font-size:12px;color:#777}"+
      ".s2s-qty{display:inline-flex;align-items:center;border:1px solid #ddd;border-radius:6px;margin-top:6px}"+
      ".s2s-qty button{background:none;border:none;width:26px;height:26px;cursor:pointer}"+
      ".s2s-foot{border-top:1px solid "+(ds.dividerColor||"#eee")+";padding:16px;background:"+(ds.footerBgColor||"#fff")+"}"+
      ".s2s-protection{display:flex;align-items:center;gap:10px;border:1px solid "+(ds.dividerColor||"#e5e5e5")+";border-radius:10px;padding:11px;margin:0 0 12px;background:"+(ds.drawerBgColor||"#fff")+"}"+
      ".s2s-protection-copy{min-width:0;flex:1}.s2s-protection-title{font-size:13px;font-weight:650}.s2s-protection-desc{font-size:10px;line-height:1.25;color:#777;margin-top:2px}.s2s-protection-price{font-size:12px;font-weight:650;white-space:nowrap}"+
      ".s2s-switch{position:relative;width:36px;height:20px;display:inline-block;flex:none}.s2s-switch input{opacity:0;width:0;height:0}.s2s-switch span{position:absolute;inset:0;border-radius:999px;background:#d1d5db;cursor:pointer;transition:.2s}.s2s-switch span:before{content:'';position:absolute;width:16px;height:16px;left:2px;top:2px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.22);transition:.2s}.s2s-switch input:checked+span{background:"+(dprotection.accentColor||"#22c55e")+"}.s2s-switch input:checked+span:before{transform:translateX(16px)}"+
      ".s2s-go{width:100%;border:none;color:"+(dcheckout.textColor||"#fff")+";padding:14px;border-radius:"+(dcheckout.borderRadius||"8px")+";font-weight:"+(dcheckout.fontWeight||"600")+";cursor:pointer;font-size:"+(dcheckout.fontSize||"15px")+"}"+
      ".s2s-target{font-size:12px;color:#666;margin-top:8px;text-align:center}"+
      ".s2s-payments{display:none;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap;margin-top:14px}.s2s-payments img{display:block;width:38px;height:24px;object-fit:contain}"+
      (isMinimalShopCart ? ".s2s-panel{width:420px;box-shadow:-8px 0 30px rgba(0,0,0,.18);font-family:Arial,Helvetica,sans-serif}.s2s-head{height:74px;box-sizing:border-box;padding:0 20px;font-size:30px;font-weight:400;letter-spacing:-.8px}.s2s-x{font-size:27px;font-weight:300}.s2s-items{padding:0 20px}.s2s-item{display:grid;grid-template-columns:92px minmax(0,1fr) 94px;align-items:start;gap:12px;padding:20px 0}.s2s-item img{width:92px;height:72px;border-radius:4px}.s2s-item-copy>div:first-child{font-size:13px!important;font-weight:700!important;line-height:1.15}.s2s-item-side{min-height:72px}.s2s-remove{height:18px;margin-bottom:5px;font-size:15px;line-height:1}.s2s-item-prices{flex-direction:column;align-items:flex-end;gap:3px;margin-top:0}.s2s-compare-price{font-size:11px}.s2s-current-price{font-size:15px;font-weight:700}.s2s-qty{height:36px;border-color:#d4d4d8;border-radius:6px;margin-top:12px}.s2s-qty button{width:34px;height:34px}.s2s-foot{padding:18px 20px 20px}.s2s-protection{border-radius:8px;padding:12px}.s2s-go{height:48px;padding:0;border-radius:6px;font-size:14px;font-weight:700}.s2s-payments{display:flex}@media(max-width:380px){.s2s-items{padding:0 14px}.s2s-item{grid-template-columns:78px minmax(0,1fr) 86px;gap:9px}.s2s-item img{width:78px;height:66px}}" : "");
    document.head.appendChild(styleEl);

    var CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
    var btn = document.createElement("button");
    btn.className = "s2s-btn";
    btn.setAttribute("aria-hidden", "true");
    btn.tabIndex = -1;
    btn.setAttribute("aria-label", "Abrir carrinho");
    btn.innerHTML = CART_ICON + '<span class="s2s-badge" id="s2s-badge">0</span>';
    var overlay = document.createElement("div"); overlay.className = "s2s-overlay";
    var panel = document.createElement("div"); panel.className = "s2s-panel" + (isMinimalShopCart ? " s2s-minimal-shop-cart" : ""); panel.setAttribute("data-s2s-owned", "true"); panel.setAttribute("data-s2s-template", isMinimalShopCart ? "minimal-shop-cart" : "rocketz");
    var bodyOverflowBeforeRocketz = document.body.style.overflow || "";
    function suppressForeignCartState(keepPageLocked){
      ["#hc-drawer", "#hc-overlay", "cart-drawer", "#CartDrawer", "#cart-drawer"].forEach(function(selector){
        document.querySelectorAll(selector).forEach(function(el){
          ["is-open", "open", "active", "animate", "menu-opening"].forEach(function(name){
            if (el.classList.contains(name)) el.classList.remove(name);
          });
          if (el.hasAttribute("open")) el.removeAttribute("open");
          if (el.getAttribute("aria-hidden") !== "true") el.setAttribute("aria-hidden", "true");
        });
      });
      document.body.style.overflow = keepPageLocked ? "hidden" : bodyOverflowBeforeRocketz;
    }
    var protectionHtml = protectionEnabled ? '<div class="s2s-protection"><span aria-hidden="true" style="color:'+(dprotection.accentColor||"#22c55e")+'">✓</span><div class="s2s-protection-copy"><div class="s2s-protection-title">'+escapeHtml(dprotection.title||"Proteção & Seguro")+'</div><div class="s2s-protection-desc">'+escapeHtml(dprotection.description||"Proteja seu pedido durante o envio.")+'</div></div><strong class="s2s-protection-price">+'+moneyHtml(Number(dprotection.price)||0)+'</strong><label class="s2s-switch"><input id="s2s-shipping-protection-toggle" type="checkbox" '+(dprotection.defaultSelected===false?'':'checked')+'><span></span></label></div>' : '';
    var paymentMarks = [["apple_pay","Apple Pay"],["google_pay","Google Pay"],["paypal","PayPal"],["american_express","American Express"],["visa","Visa"],["master","Mastercard"],["shopify_pay","Shop Pay"],["maestro","Maestro"]];
    var paymentsHtml = isMinimalShopCart ? '<div class="s2s-payments" aria-label="Formas de pagamento">'+paymentMarks.map(function(mark){return '<img src="'+API+'/payment-icons/'+mark[0]+'.svg" width="38" height="24" alt="'+mark[1]+'">';}).join('')+'</div>' : '';
    panel.innerHTML = '<div class="s2s-head"><span id="s2s-head-title">'+escapeHtml(dh.title||"Seu carrinho")+'</span><button class="s2s-x" id="s2s-x" aria-label="Fechar">&times;</button></div>'+
      '<div class="s2s-items" id="s2s-items"></div>'+
      '<div class="s2s-foot"><div style="display:flex;justify-content:space-between;margin-bottom:12px"><span>Subtotal</span><strong id="s2s-sub"></strong></div>'+
      protectionHtml+
      '<button class="s2s-go" id="s2s-go"></button>'+
      paymentsHtml+
      '<div class="s2s-target" id="s2s-target"></div></div>';
    document.body.appendChild(btn); document.body.appendChild(overlay); document.body.appendChild(panel);

    var guardedForeignCarts = new WeakSet();
    var foreignCartGuard = new MutationObserver(function(){
      suppressForeignCartState(panel.classList.contains("open"));
    });
    function bindForeignCartGuards(){
      document.querySelectorAll("#hc-drawer, #hc-overlay, cart-drawer, #CartDrawer, #cart-drawer").forEach(function(el){
        if (guardedForeignCarts.has(el)) return;
        guardedForeignCarts.add(el);
        foreignCartGuard.observe(el, { attributes:true, attributeFilter:["class", "style", "open", "aria-hidden"] });
      });
    }
    bindForeignCartGuards();

    window.__s2s_openPanel = openPanel;
    window.__s2s_addFromForm = addFromForm;
    window.__s2s_render = render;

    btn.addEventListener("click", openPanel);
    overlay.addEventListener("click", closePanel);
    panel.querySelector("#s2s-x").addEventListener("click", closePanel);

    function openPanel(){
      warmShopCurrency();
      panel.classList.add("open");
      overlay.style.display="block";
      suppressForeignCartState(true);
      [0, 50, 250, 1000].forEach(function(delay){
        setTimeout(function(){ bindForeignCartGuards(); suppressForeignCartState(true); }, delay);
      });
      render();
      schedulePrepareChoices(load(), 0);
    }
    function closePanel(){
      panel.classList.remove("open");
      overlay.style.display="none";
      suppressForeignCartState(false);
      setTimeout(function(){ suppressForeignCartState(false); }, 50);
    }

    // The exclusive theme guard is installed before theme/app listeners. If a
    // shopper clicks while this async ScriptTag is still loading, complete the
    // queued action now instead of letting the native drawer flash or close us.
    try {
      var pendingAddForm = window.__ROCKETZ_PENDING_ADD_FORM__;
      window.__ROCKETZ_PENDING_ADD_FORM__ = null;
      if (pendingAddForm && pendingAddForm.isConnected) addFromForm(pendingAddForm);
      if (window.__ROCKETZ_PENDING_CART_OPEN__) {
        window.__ROCKETZ_PENDING_CART_OPEN__ = false;
        openPanel();
      }
    } catch(e){}

    // Apply styles
    var pos = SETTINGS.position === "bottom-left" ? "left:20px" : "right:20px";
    btn.setAttribute("style", pos + ";bottom:20px;background:" + SETTINGS.primary_color);
    var goInit = panel.querySelector("#s2s-go");
    goInit.style.background = dcheckout.backgroundColor || SETTINGS.primary_color;
    goInit.textContent = dcheckout.text || SETTINGS.button_text || "Finalizar compra";
    panel.querySelector("#s2s-target").style.display = SETTINGS.show_target_store ? "block" : "none";

    function render(){
      var items = load();
      var count = items.reduce(function(s,i){ return s + (i.quantity||0); }, 0);
      document.getElementById("s2s-badge").textContent = count;
      var headTitle = document.getElementById("s2s-head-title");
      if (headTitle) headTitle.textContent = (dh.title||"Seu carrinho") + (isMinimalShopCart ? " · " + count : "");
      var sub = items.reduce(function(s,i){ return s + (i.price||0)*(i.quantity||0); }, 0);
      var protectionPrice = panel.querySelector(".s2s-protection-price");
      if (protectionPrice) protectionPrice.innerHTML = "+" + moneyHtml(protectionPriceValue());
      document.getElementById("s2s-sub").innerHTML = moneyHtml(sub);
      var box = document.getElementById("s2s-items");
      if (!items.length){ box.innerHTML = '<p style="text-align:center;color:#888;padding:40px 0">Seu carrinho está vazio.</p>'; syncStorefrontMoney(); return; }
      box.innerHTML = items.map(function(i){
        var giftItem = isGiftItem(i);
        var showCompareAt = Number(i.compare_at_price) > Number(i.price);
        var savings = showCompareAt ? Number(i.compare_at_price) - Number(i.price) : 0;
        if (isMinimalShopCart) {
          return '<div class="s2s-item">'+
            cartImageMarkup(i, true)+
            '<div class="s2s-item-copy">'+
              '<div>'+escapeHtml(i.title||"")+'</div>'+
              (i.variant_title?'<div style="font-size:12px;color:#666;margin-top:4px">'+escapeHtml(i.variant_title)+'</div>':'')+
              (giftItem ? '<div class="s2s-gift-qty">1×</div>' : '<div class="s2s-qty">'+
                '<button data-act="dec" data-id="'+i.variant_id+'">-</button>'+
                '<span style="padding:0 10px">'+i.quantity+'</span>'+
                '<button data-act="inc" data-id="'+i.variant_id+'">+</button>'+
              '</div>')+
            '</div>'+
            '<div class="s2s-item-side">'+
              (giftItem ? '' : '<button class="s2s-remove" data-act="rm" data-id="'+i.variant_id+'" aria-label="Remover item">&#128465;</button>')+
              '<div class="s2s-item-prices">'+
                (showCompareAt?'<span class="s2s-compare-price">'+moneyHtml(i.compare_at_price)+'</span>':'')+
                '<span class="s2s-current-price'+(giftItem?' s2s-gift-price':'')+'">'+(giftItem ? escapeHtml(t(giftConfig().labelMode === "gift" ? "giftLabel" : "giftFree")) : moneyHtml(i.price))+'</span>'+
                (showCompareAt?'<span class="s2s-saving">'+escapeHtml(t("save"))+' '+moneyHtml(savings)+'</span>':'')+
              '</div>'+
            '</div>'+
          '</div>';
        }
        return '<div class="s2s-item">'+
          cartImageMarkup(i, isMinimalShopCart)+
          '<div class="s2s-item-copy">'+
            '<div style="font-weight:600;font-size:14px">'+escapeHtml(i.title||"")+'</div>'+
            (i.variant_title?'<div style="font-size:12px;color:#666">'+escapeHtml(i.variant_title)+'</div>':'')+
            '<div class="s2s-item-prices">'+
              (showCompareAt?'<span class="s2s-compare-price">'+moneyHtml(i.compare_at_price)+'</span>':'')+
              '<span class="s2s-current-price'+(giftItem?' s2s-gift-price':'')+'">'+(giftItem ? escapeHtml(t(giftConfig().labelMode === "gift" ? "giftLabel" : "giftFree")) : moneyHtml(i.price))+'</span>'+
            '</div>'+
            (giftItem ? '<div class="s2s-gift-qty">1×</div>' : '<div class="s2s-qty">'+
              '<button data-act="dec" data-id="'+i.variant_id+'">-</button>'+
              '<span style="padding:0 10px">'+i.quantity+'</span>'+
              '<button data-act="inc" data-id="'+i.variant_id+'">+</button>'+
            '</div>')+
          '</div>'+
          (giftItem ? '' : '<button class="s2s-remove" data-act="rm" data-id="'+i.variant_id+'">&times;</button>')+
        '</div>';
      }).join("");
      box.querySelectorAll("button[data-act]").forEach(function(b){
        b.addEventListener("click", function(){
          var id = b.getAttribute("data-id"); var act = b.getAttribute("data-act");
          var it = load().find(function(x){ return String(x.variant_id)===String(id); });
          if (act==="rm") removeItem(id);
          else if (act==="inc") setQty(id, (it?it.quantity:1)+1);
          else if (act==="dec") setQty(id, (it?it.quantity:2)-1);
        });
      });
      syncStorefrontMoney();
    }

    document.getElementById("s2s-go").addEventListener("click", function(){
      if (!acquireCheckoutLock()) return;
      var items = load();
      if (!items.length) { releaseCheckoutLock(); return; }
      var go = document.getElementById("s2s-go");
      showCheckoutLoader(go);
      doCheckout(items, function(err){
        if (err) alert(err);
      });
    });
    var protectionToggle = document.getElementById("s2s-shipping-protection-toggle");
    if (protectionToggle) protectionToggle.addEventListener("change", function(){
      schedulePrepareChoices(load(), 0);
    });

    render();
    var currentItems = load();
    schedulePrepareChoices(currentItems, 0);

    // Resolve a próxima loja e o mapeamento da variante enquanto o cliente
    // ainda está na página do produto. Assim, adicionar ao carrinho e clicar
    // em checkout não coloca a API no caminho crítico do redirecionamento.
    var productPrimeTimer = null;
    function primeProductCheckout(form){
      var anticipated = anticipatedItemsFromForm(form);
      if (!anticipated || !anticipated.length) return;
      schedulePrepareChoices(anticipated, 0);
    }
    function primeVisibleProductForm(){
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="id"]')) { primeProductCheckout(forms[i]); return; }
      }
    }
    document.addEventListener("change", function(event){
      var target = event.target;
      if (!target || !target.closest) return;
      var form = target.closest('form[action*="/cart/add"]');
      var variantPicker = target.closest('variant-selects, variant-radios, [data-option-selector], .product-form__input');
      if (!form && !variantPicker) return;
      if (productPrimeTimer) clearTimeout(productPrimeTimer);
      productPrimeTimer = setTimeout(function(){
        if (form) primeProductCheckout(form);
        else primeVisibleProductForm();
      }, 80);
    }, true);
  }



  // ============================================================
  // MODE B: Carrinho nativo da Shopify
  // ============================================================
  function initNativeMode(){
    if (nativeModeStarted) return;
    nativeModeStarted = true;
    // No modo nativo o carrinho da loja precisa ficar visível: remove qualquer ocultação.
    try { var hn = document.getElementById("s2s-hide-native"); if (hn) hn.remove(); } catch(e){}
    // Botões de checkout expresso pulam nossa interceptação: sempre escondidos no modo nativo.
    if (!document.getElementById("s2s-hide-express")) {
      var s = document.createElement("style");
      s.id = "s2s-hide-express";
      s.textContent = [
        // Shopify dynamic checkout buttons
        ".shopify-payment-button, .additional-checkout-buttons,",
        "[data-shopify=\"payment-button\"], shopify-payment-terms,",
        // Shop Pay / Apple Pay / Google Pay / PayPal generic hooks
        ".shop-pay-button, shop-pay-button, [class*=\"apple-pay\"],",
        "[class*=\"google-pay\"], [class*=\"paypal\"], [id*=\"paypal\"],",
        ".dynamic-checkout__content, .dynamic-checkout__button {",
        "  display: none !important;",
        "}"
      ].join("");
      document.head.appendChild(s);
    }

    function syncNativeCart(){
      if (nativeCartRead) return nativeCartRead;
      var revision = nativeCartRevision;
      nativeCartRead = fetch(cartUrl("cart.js"), { headers:{ "Accept":"application/json" }, signal:AbortSignal.timeout(8000) })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(cart){
          if (!cart) throw new Error("Não foi possível atualizar o carrinho");
          applyShopCartContext(cart);
          if (revision !== nativeCartRevision || nativeCartPending) return;
          var items = (cart.items || []).map(function(it){
            return {
              variant_id:String(it.variant_id || it.id),
              quantity:it.quantity || 1,
              price:(typeof it.final_price === "number" ? it.final_price : (it.price || 0)) / 100
            };
          });
          var changed = cartFingerprint(items) !== cartFingerprint(lastNativeItems);
          lastNativeItems = items;
          nativeCartDirty = false;
          if (changed) invalidatePreparedCheckout();
          schedulePrepareChoices(items, 0);
          updateRazeButton();
          reportCart();
          return items;
        }).finally(function(){
          nativeCartRead = null;
          if (revision !== nativeCartRevision && !nativeCartPending) scheduleNativeCartSync(0);
        });
      return nativeCartRead;
    }
    syncNativeCartNow = syncNativeCart;
    function scheduleNativeCartSync(delay){
      if (nativeCartSyncTimer) clearTimeout(nativeCartSyncTimer);
      nativeCartSyncTimer = setTimeout(function(){ syncNativeCart().catch(function(){ nativeCartDirty = true; updateRazeButton(); reportCart(); }); }, typeof delay === "number" ? delay : 80);
    }

    function isCartMutation(input){
      try {
        var u = new URL(typeof input === "string" ? input : input.url || String(input), location.href);
        return u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname);
      } catch(e){ return false; }
    }
    function mutationStarted(){
      nativeCartPending++; nativeCartRevision++; nativeCartDirty = true;
      invalidatePreparedCheckout(); updateRazeButton(); reportCart();
    }
    function mutationFinished(){
      nativeCartPending = Math.max(0, nativeCartPending - 1);
      if (!nativeCartPending) scheduleNativeCartSync(0);
    }
    var originalFetch = window.fetch;
    function isNativeAddition(input){
      try {
        var u = new URL(typeof input === "string" ? input : input.url || String(input), location.href);
        return u.origin === location.origin && /\/cart\/add(\.js)?$/.test(u.pathname);
      } catch(e){ return false; }
    }
    function trackNativeAddition(payload){
      var lines = payload && Array.isArray(payload.items) ? payload.items : payload && payload.product_id ? [payload] : [];
      var products = {};
      lines.forEach(function(line){ if (line.product_id) products[String(line.product_id)] = true; });
      var items = Object.keys(products).map(function(id){ return { product_id:id, quantity:1 }; });
      // Count successful addition actions, not the cumulative cart-line quantity.
      if (items.length) track("AddToCart", { product_items:items, content_ids:lines.map(function(line){ return String(line.variant_id || line.id); }) });
    }
    window.fetch = function(input){
      var mutation = isCartMutation(input);
      if (mutation) mutationStarted();
      try {
        var result = originalFetch.apply(this, arguments);
        if (isNativeAddition(input)) result.then(function(response){
          if (response.ok) response.clone().json().then(trackNativeAddition).catch(function(){});
        }).catch(function(){});
        return mutation ? result.finally(mutationFinished) : result;
      } catch(error){ if (mutation) mutationFinished(); throw error; }
    };
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    var mutatingRequests = new WeakSet();
    var additionRequests = new WeakSet();
    XMLHttpRequest.prototype.open = function(method, url){
      mutatingRequests.delete(this);
      if (isCartMutation(url)) mutatingRequests.add(this);
      additionRequests.delete(this);
      if (isNativeAddition(url)) additionRequests.add(this);
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      var mutation = mutatingRequests.has(this);
      var finished = false;
      function finish(){ if (!finished) { finished = true; mutationFinished(); } }
      if (mutation) { mutationStarted(); this.addEventListener("loadend", finish, { once:true }); }
      if (additionRequests.has(this)) this.addEventListener("load", function(){
        if (this.status >= 200 && this.status < 300) {
          try { trackNativeAddition(this.responseType === "json" ? this.response : JSON.parse(this.responseText)); } catch(e){}
        }
      }, { once:true });
      try { return originalSend.apply(this, arguments); }
      catch(error){ if (mutation) finish(); throw error; }
    };

    document.addEventListener("submit", function(e){
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action.indexOf("/cart/add") !== -1 || action.indexOf("/cart/change") !== -1 || action.indexOf("/cart/update") !== -1) {
        scheduleNativeCartSync(120);
        setTimeout(function(){ scheduleNativeCartSync(0); }, 500);
      }
    }, true);
    ["cart:updated","cart:change","cart:refresh","ajaxProduct:added","product:added"].forEach(function(name){
      document.addEventListener(name, function(){ nativeCartDirty = true; nativeCartRevision++; invalidatePreparedCheckout(); scheduleNativeCartSync(30); });
    });
    window.addEventListener("focus", function(){ scheduleNativeCartSync(0); });
    window.addEventListener("pageshow", function(){ scheduleNativeCartSync(0); });
    scheduleNativeCartSync(0);

  }

  /**
   * Interceptação global do checkout nativo.
   *
   * Instalada IMEDIATAMENTE (antes mesmo das configurações carregarem) para que
   * um clique rápido nunca escape para o checkout da própria loja vitrine.
   * A ação real começa imediatamente usando a última configuração conhecida.
   */
  function installInterceptors(){
    // Sequestra qualquer intenção de ir para o checkout nativo:
    // - submit em form com action /cart ou /checkout
    // - clique em <button name="checkout"> ou link para /checkout
    document.addEventListener("submit", function(e){
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = (form.getAttribute("action")||"").toLowerCase();
      if (action.indexOf("/checkout") === -1 && action.indexOf("/cart") === -1) return;
      // Só interceptar quando o submit for o botão "checkout" (não o "update").
      var submitter = e.submitter;
      var isCheckout = false;
      if (submitter) {
        var name = (submitter.getAttribute("name")||"").toLowerCase();
        var val = (submitter.getAttribute("value")||"").toLowerCase();
        if (name === "checkout" || val.indexOf("checkout") !== -1) isCheckout = true;
      }
      if (action.indexOf("/checkout") !== -1) isCheckout = true;
      if (!isCheckout) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleCheckoutIntent(submitter || form);
    }, true);

    // Clique: cobre links /checkout, botões name="checkout" e botões de apps
    // de carrinho de terceiros (UpCart, Slide Cart, Rebuy, Monster Cart...)
    var APP_SELECTORS = [
      "[name=\"checkout\"]",
      "[href*=\"/checkout\"]",
      "[class*=\"upcart\"][class*=\"checkout\"]",
      "[class*=\"cart\"][class*=\"checkout-button\"]",
      "[class*=\"checkout-button\"]",
      "[id*=\"checkout-button\"]",
      "[data-checkout]",
      "#hc-drawer #hc-checkout",
      ".cart__checkout, .cart-checkout, .btn--checkout"
    ].join(",");
    var CHECKOUT_TEXT = /(finalizar\s+(compra|pedido)|ir\s+para\s+o?\s*checkout|checkout|comprar\s+agora)/i;

    function looksLikeCheckout(el){
      try {
        // O botão do nosso drawer já possui seu próprio fluxo e usa o carrinho
        // salvo pelo Shop2Shops, não o /cart.js da vitrine.
        if (el.id === "s2s-go") return false;
        if (el.matches && el.matches(APP_SELECTORS)) return true;
        var tag = el.tagName;
        if (tag !== "BUTTON" && tag !== "A" && el.getAttribute("role") !== "button") return false;
        var txt = (el.textContent || "").trim();
        if (!txt || txt.length > 40) return false;
        // Evita sequestrar "adicionar ao carrinho"
        if (/adicionar|add to cart|carrinho de compras/i.test(txt)) return false;
        return CHECKOUT_TEXT.test(txt);
      } catch(e){ return false; }
    }

    function onCheckoutIntent(e){
      var path = e.composedPath ? e.composedPath() : [];
      var t = path[0] || e.target;
      while (t && t !== document.body){
        if (t.nodeType === 1 && looksLikeCheckout(t)){
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          if (checkoutInFlight) return;
          handleCheckoutIntent(t);
          return;
        }
        t = t.parentNode || t.host;
      }
    }
    // Um único listener de click em capture cobre desktop e mobile. Interceptar
    // pointerdown/touchstart desabilitava o botão antes do click em alguns temas.
    window.addEventListener("click", onCheckoutIntent, true);
    var checkoutRoots = new WeakSet();
    bindCheckoutRoot = function(root){
      if (!root || root === document || !root.addEventListener || checkoutRoots.has(root)) return;
      checkoutRoots.add(root);
      root.addEventListener("click", onCheckoutIntent, true);
    };

    // Trava de segurança: apps que navegam por JavaScript puro
    function isCheckoutUrl(u){
      try {
        var s = String(u || "");
        if (!s) return false;
        var path = s.indexOf("://") > -1 ? new URL(s, location.href).pathname : s.split("?")[0];
        return path.indexOf("/checkout") === 0 || /\/checkouts?\//.test(path);
      } catch(e){ return false; }
    }
    try {
      var origAssign = window.location.assign.bind(window.location);
      window.location.assign = function(u){ if (isCheckoutUrl(u)) { handleCheckoutIntent(null); return; } return origAssign(u); };
      var origReplace = window.location.replace.bind(window.location);
      window.location.replace = function(u){ if (isCheckoutUrl(u)) { handleCheckoutIntent(null); return; } return origReplace(u); };
    } catch(e){}
    try {
      var origOpen = window.open;
      window.open = function(u){ if (isCheckoutUrl(u)) { handleCheckoutIntent(null); return null; } return origOpen.apply(window, arguments); };
    } catch(e){}
    try {
      var origSubmit = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function(){
        var a = (this.getAttribute("action") || "").toLowerCase();
        if (a.indexOf("/checkout") !== -1) { handleCheckoutIntent(null); return; }
        return origSubmit.apply(this, arguments);
      };
    } catch(e){}
  }

  /** Bloqueia o checkout da vitrine e inicia a transferência imediatamente. */
  function handleCheckoutIntent(el){
    if (el && (el.disabled || el.getAttribute("aria-disabled") === "true") && !checkoutInFlight) return;
    if (!acquireCheckoutLock()) return;
    try {
      showCheckoutLoader(el);
      startNativeCheckout(el);
    } catch(error){ releaseCheckoutLock(); alert(error.message || "Não foi possível iniciar o checkout. Tente novamente."); }
  }

  document.addEventListener("change", function(event){
    var target = event.target;
    if (!target || target.id !== "hc-shipping-protection-toggle") return;
    if (lastNativeItems && lastNativeItems.length) schedulePrepareChoices(lastNativeItems, 0);
  }, true);

  function startNativeCheckout(triggerEl){
    showCheckoutLoader(triggerEl);
    if (nativeCartPending) {
      var started = Date.now();
      var wait = setInterval(function(){
        if (!nativeCartPending) { clearInterval(wait); startNativeCheckout(triggerEl); }
        else if (Date.now() - started > 10000) { clearInterval(wait); releaseCheckoutLock(); alert("O carrinho ainda está sendo atualizado. Tente novamente."); }
      }, 50);
      return;
    }
    if (nativeCartDirty && syncNativeCartNow) {
      syncNativeCartNow().then(function(){
        if (nativeCartDirty) throw new Error("O carrinho mudou. Tente novamente.");
        startNativeCheckout(triggerEl);
      }).catch(function(err){ releaseCheckoutLock(); alert(err.message || "Não foi possível atualizar o carrinho."); });
      return;
    }
    if (lastNativeItems && lastNativeItems.length) {
      doCheckout(lastNativeItems, function(err){ if (err) alert(err); });
      return;
    }
    fetch(cartUrl("cart.js"), { headers: { "Accept": "application/json" }, signal:AbortSignal.timeout(8000) })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        applyShopCartContext(cart);
        var items = (cart.items || []).map(function(it){
          return { variant_id: String(it.variant_id || it.id), quantity: it.quantity || 1 };
        });
        if (!items.length) {
          releaseCheckoutLock();
          alert("Seu carrinho está vazio.");
          return;
        }
        lastNativeItems = items;
        doCheckout(items, function(err){
          if (err) alert(err);
        });
      })
      .catch(function(){
        releaseCheckoutLock();
        alert("Não foi possível ler o carrinho.");
      });
  }

  var routePollPending = false;
  function refreshRouteRevision(){
    var plans = Object.keys(preparedCheckouts).map(function(key){ return preparedCheckouts[key]; });
    var items = activeCart === "shop2shops" ? load().map(function(it){return {variant_id:it.variant_id,quantity:it.quantity};}) : lastNativeItems;
    if (routePollPending || document.hidden || checkoutInFlight || !items || !items.length ||
        (!routePollingEnabled && !plans.some(function(plan){return plan.route_revision;}))) return;
    routePollPending = true;
    return fetch(API + "/api/public/s2s-checkout?workspace_id=" + encodeURIComponent(cfg.workspace_id) +
      "&vitrine_store_id=" + encodeURIComponent(cfg.vitrine_store_id), {
      signal:AbortSignal.timeout(5000), cache:"no-store"
    }).then(function(r){ if (!r.ok) throw new Error("Rota indisponível"); return r.json(); }).then(function(d){
      if (plans.some(function(plan){ return plan.route_revision !== d.route_revision; })) invalidatePreparedCheckout();
      else { plans.forEach(function(plan){plan.revision_verified_at=Date.now();}); persistPreparedCheckouts(); }
      if (items && items.length) prepareCheckoutChoices(items).catch(function(err){console.error("[s2s] route refresh",err);});
    }).catch(function(err){
      invalidatePreparedCheckout();
      console.error("[s2s] route verification",err);
    }).finally(function(){routePollPending=false;});
  }
  setInterval(refreshRouteRevision, 10000);
  document.addEventListener("visibilitychange",function(){if(!document.hidden)refreshRouteRevision();});

  // Shared checkout call
  function doCheckout(items, done){
    var revision = nativeCartRevision;
    function fail(msg){ releaseCheckoutLock(); hideCheckoutLoader(); done(msg); }
    showCheckoutLoader();
    if (!cfg.workspace_id || !cfg.vitrine_store_id) { fail("Carrinho não configurado. Reinstale o script pela loja no Shop2Shops."); return; }
    if (!API) { fail("URL da API não configurada. Reinstale o script pela loja no Shop2Shops."); return; }
    var ready = readPreparedCheckout(items);
    if (ready) {
      redirectToPreparedCheckout(ready, items);
      return;
    }
    // Normalmente esta promise já começou no add-to-cart/abertura do drawer.
    // Se o cliente clicar muito rápido, apenas aguardamos o preparo em andamento.
    prepareCheckout(items, false).then(function(plan){
      if (!plan || !plan.checkout_url) throw new Error("Checkout ainda não preparado");
      if (activeCart !== "shop2shops" && (revision !== nativeCartRevision || nativeCartDirty || nativeCartPending)) {
        startNativeCheckout(checkoutLoadingButton);
        return;
      }
      redirectToPreparedCheckout(plan, items);
    }).catch(function(err){
      fail("Erro de conexão com o servidor do carrinho: " + (err && err.message ? err.message : "verifique sua internet"));
    });
  }

  // ============================================================
  // Boot: load settings then activate the chosen mode
  // ============================================================
  function boot(){
    var external = detectExternalCart();
    var forceRocketzCart = SETTINGS.use_native_cart === false && !!SETTINGS.drawer_config;
    activeCart = forceRocketzCart ? "shop2shops" : (external || ((SETTINGS.use_native_cart || (_q.get("cart") === "auto" && !SETTINGS.cart_configured)) ? "shopify" : "shop2shops"));
    if (activeCart === "shop2shops") initDrawerMode();
    else initNativeMode();
    if (activeCart === "shop2shops") warmShopCurrency();
    reportCart();
    connectUpcart();
    var scheduled = false;
    var lastCheckoutContext = JSON.stringify(checkoutBuyerContext());
    new MutationObserver(function(){
      if (scheduled) return;
      scheduled = true;
      setTimeout(function(){
        scheduled = false;
        var nextCheckoutContext = JSON.stringify(checkoutBuyerContext());
        if (nextCheckoutContext !== lastCheckoutContext) {
          lastCheckoutContext = nextCheckoutContext;
          invalidatePreparedCheckout();
          var currencyItems = activeCart === "shop2shops" ? load() : lastNativeItems;
          if (currencyItems && currencyItems.length) schedulePrepareChoices(currencyItems, 0);
        }
        var provider = detectExternalCart();
        if (!forceRocketzCart && provider && provider !== activeCart && !(activeCart === "shop2shops" && load().length)) {
          activeCart = provider;
          document.querySelectorAll(".s2s-btn, .s2s-panel, .s2s-overlay").forEach(function(el){ el.style.display = "none"; });
          initNativeMode();
          reportCart();
        }
        updateRazeButton();
        connectUpcart();
      }, 30);
    }).observe(document.documentElement, { subtree:true, childList:true, attributes:true, attributeFilter:["disabled"] });
    updateRazeButton();
  }

  // Última configuração conhecida: evita cair no checkout da vitrine caso a
  // requisição de configurações falhe ou demore.
  try {
    var cached = JSON.parse(localStorage.getItem(SETTINGS_KEY) || "null");
    if (cached && typeof cached === "object") { Object.assign(SETTINGS, cached); SETTINGS.cart_configured = typeof cached.use_native_cart === "boolean"; }
    var cachedPixels = JSON.parse(localStorage.getItem(PIXELS_KEY) || "null");
  } catch(e){}

  // Interceptação sobe antes de tudo — nenhum clique escapa.
  try { installInterceptors(); } catch(e){}

  // Ao voltar pelo bfcache, garante que o loader/trava não fiquem presos.
  try {
    window.addEventListener("pageshow", function(e){
      if (e && e.persisted) releaseCheckoutLock();
    });
  } catch(e){}

  fetch(API + "/api/public/s2s-settings?workspace_id=" + encodeURIComponent(cfg.workspace_id||"") + "&vitrine_store_id=" + encodeURIComponent(cfg.vitrine_store_id||""), { signal:AbortSignal.timeout(5000) })
    .then(function(r){ return r.json(); })
    .then(function(s){
      if (s && s.cart) {
        Object.assign(SETTINGS, s.cart);
        SETTINGS.cart_configured = typeof s.cart.use_native_cart === "boolean";
        try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(s.cart)); } catch(e){}
      }
      if (s && Array.isArray(s.tracking_pixels)) {
        configureBrowserPixels(s.tracking_pixels);
        try { localStorage.setItem(PIXELS_KEY, JSON.stringify(s.tracking_pixels)); } catch(e){}
      }
      trackPageViewOnce();
      boot();
    })
    .catch(function(){
      if (Array.isArray(cachedPixels)) configureBrowserPixels(cachedPixels);
      trackPageViewOnce();
      boot();
    });
})();